import { useEcho } from '@laravel/echo-vue';
import { onMounted, ref } from 'vue';

export type ProjectEvent = {
    type: string;
    payload: Record<string, unknown>;
    timestamp: string;
};

export function useProjectChannel(projectId: string | number) {
    const projectEvents = ref<ProjectEvent[]>([]);

    const pushEvent = (e: Record<string, unknown>) => {
        const type = (e.event as string) ?? (e.type as string) ?? 'unknown';

        projectEvents.value = [
            ...projectEvents.value,
            {
                type,
                payload: e,
                timestamp: new Date().toISOString(),
            },
        ];
    };

    onMounted(() => {
        useEcho(
            `project.${projectId}`,
            [
                '.project.papers_imported',
                '.project.run_completed',
                '.project.extraction_updated',
                '.run.failed',
                '.run.started',
                '.project.file_uploaded',
                '.project.pdf_matched',
            ],
            (e) => pushEvent(e),
        );
    });

    return {
        projectEvents,
    };
}
